  <!-- [if IE]> <p class="browserupgrade"> You are using an <strong>outdated</strong> browser. Please <a href="https://browsehappy.com/">upgrade your browser</a> to improve your experience and security. </p> <![endif] -->
<main class="app-wrapper"
[class.extend]="dashcodeHelper.Settings.menuIsExtended"
[class.collapsed]="dashcodeHelper.Settings.menuIsCollapsed">

    <dashlayout-sidebar></dashlayout-sidebar>
    <!-- <dashlayout-settings></dashlayout-settings> -->


<div class="flex flex-col justify-between min-h-screen">
    <div>
        <dashlayout-header></dashlayout-header>
        <div class="content-wrapper transition-all duration-150 ltr:ml-[248px] rtl:mr-[248px]" id="content_wrapper" [class.margin-0]="dashcodeHelper.Settings.isSmallScreen">
          <div class="page-content">
            <div class="transition-all duration-150 container-fluid" id="page_layout">
              <div id="content_layout">

                <ng-content></ng-content>
                </div>
                </div>
              </div>
            </div>
        <!-- <router-outlet></router-outlet> -->
    </div>
      <dashlayout-footer></dashlayout-footer>
  </div>
  </main>
